<template>
<div class="partner">
    <indexTitle english_title="Exhibition" chinese_title="近期展覽" page='true'></indexTitle>
    <div id="searchbox">
        <moreButton class="searchbtn" :class="{ 'searchbox': item.status}" @click.native="search_exhibit(item.id)" :button_text="item.name" button_href="" v-for="item in regions" :key="item.id"></moreButton>
    </div>
    <div class="partner_center">
        <div class="partner_box" v-for="item in exhibit" :key="item.id">
            <a class="imgurl" :href="item.demo_url" target="_blank">
              <div class="partner_img"><img :src="item.image_url" :alt="item.id"></div>
            </a>
            <div class="partner_text">
                <a :href="item.title_url" target="_blank">
                    <p class="partner_title">{{item.short}}</p>
                </a>
                <p class="partner_date"><i class="fa fa-calendar"></i>{{item.start_date}}~{{item.end_date}}</p>
                <p class="partner_location"><i class="fa fa-map-marker "></i>{{item.address.name}}</p>
                <p class="partner_btn">
                    <a class="admin_url" target="_blank" :href="item.url">展覽網址</a>&nbsp;&nbsp;
                    <!-- <a class="admin_url" target="_blank" :href="item.demo_url">Demo</a>&nbsp;&nbsp; -->
                    <a class="admin_url" target="_blank" :href="item.admin_url">展覽後台</a>
                </p>
            </div>
        </div>
    </div>
    <div v-show="api_data==false" style="margin:40px auto;font-size:21px;text-align: center;">
        <img src="../../assets/loading.gif">
    </div>
    <div v-show="exhibit.length== 0 &&api_data==true" style="margin-top:100px;height:200px;text-align:center;font-size: 21px;">很抱歉，查無相關展覽資訊</div>
    <moreButton button_text="返回首頁" button_href="/"></moreButton>
</div>
</template>
<script>
import IndexTitle from '@/components/index/IndexTitle'
import MoreButton from '@/components/index/MoreButton'
export default {
    components: {
        'indexTitle': IndexTitle,
        'moreButton': MoreButton,
    },
    data(){
        return{
            api_exhibit:[],//展覽資料
            exhibit:[],//過濾後展覽資料
            before_id:0,
            api_time:new Date(),
            end_time:'',//一年前時間
            api_data:false,//api判斷
            regions: [
                {id: '0', location_id: ['0'], name: '不分區',status:true},
                {id: '1', location_id: ['1','2','4','10','11','15','16','17','19'], name: '北區',status:false},
                {id: '2', location_id: ['5','6','7','9','18'], name: '中區',status:false},
                {id: '3', location_id: ['3','8','13','14'], name: '南區',status:false},
                {id: '4', location_id: ['3','8','13','14'], name: '已結束',status:false}
            ],
            categorys: [
                {category_id: '0', name: '近期展覽'},
                {category_id: '1', name: '３Ｃ家電'},
                {category_id: '2', name: '寵物用品'},
                {category_id: '3', name: '婦幼兒童'},
                {category_id: '4', name: '婚紗精品'},
                {category_id: '5', name: '建材傢俱'},
                {category_id: '6', name: '觀光旅遊'},
                {category_id: '7', name: '佛茶素展'},
                {category_id: '8', name: '專業特展'},
                {category_id: '9', name: '創業加盟'},
                {category_id: '10', name: '精緻酒展'},
                {category_id: '11', name: '休閒健康'},
                {category_id: '12', name: '汽機車展'}
            ],
        }
    },
    computed: {
      API() {
        return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
      }
    },
    mounted(){
      this.get_time()
      var vm = this
      var news_api = vm.API + 'api/tlweb/new_exhibit?end_date='+this.end_time+'&sort=start_date%20asc&rows=1000&recent=1'
      // var news_api = vm.API + 'api/tlweb/new_exhibit?end_date='+this.api_time+'&sort=start_date%20asc&rows=1000'
      this.axios.get(news_api)
      .then(function (response) {
        var exhibit_data = response.data.data.data
        vm.api_exhibit = exhibit_data.filter(function(item){
          var url =item.exhibit_domain==null?"https://demo.top-link.com.tw/"+item.id:"https://"+item.exhibit_domain.domain
          var demo_url ="https://demo.top-link.com.tw/"+item.id
          var admin_url ="https://demo.top-link.com.tw/admin/"+item.id
          item.url = url
          item.demo_url = demo_url
          item.admin_url = admin_url
          return item.exhibit_website.recent_exhibit==1
        }); 
        // console.log(vm.api_exhibit)
        vm.api_data=true;
        vm.search_exhibit(vm.before_id)    
        
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    methods:{
        search_exhibit(id){
          this.get_time()
          if(id==0){
            this.exhibit=this.api_exhibit.filter(item => 
              item.end_date>=this.api_time
            );
          }else if(id==4){
            var vm =this
            vm.exhibit = vm.api_exhibit.filter(function(item){
              var url =item.exhibit_website.url==""?"https://demo.top-link.com.tw/"+item.id:item.exhibit_website.url
              var demo_url =item.exhibit_website.url==""?"https://demo.top-link.com.tw/"+item.id:item.exhibit_website.url
              var admin_url =item.exhibit_website.url==""?"https://demo.top-link.com.tw/admin/"+item.id:"https://www.top-link.com.tw/exhibit_back/"+item.id
              item.url = url
              item.demo_url = demo_url
              item.admin_url = admin_url
              return item.end_date<vm.api_time&&item.end_date>=vm.end_time&&item.exhibit_website.template_id!=0
            }); 
            this.exhibit.reverse()
          }else{
            this.exhibit=this.api_exhibit.filter(item => 
              this.regions[id].location_id.indexOf(item.location_id)>-1&&item.end_date>=this.api_time
            );
          }
          this.regions[this.before_id].status=false
          this.regions[id].status=true
          this.before_id=id
        },
        get_time(){
          var apitime = new Date();
          var api_Year =  apitime.getFullYear()
          var api_Month = apitime.getMonth()+1<10?'0'+(apitime.getMonth()+1):apitime.getMonth()+1
          var api_Date = apitime.getDate()<10?'0'+apitime.getDate():apitime.getDate()
          this.api_time= api_Year+"-"+api_Month+"-"+api_Date
          this.end_time=(api_Year-1)+"-"+api_Month+"-"+api_Date
        }
    }
}
</script>
<style scoped>
.partner{
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
    text-align: center;
}
#searchbox{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
#searchbox >>> .more_button{
    margin: 0 5px 40px;
}
.searchbox >>> div a {
    background: #00a0e9;
    color: white;
}
.partner a{
    text-decoration: none;
    color:black;
}
.partner_center{
    display: flex;
    flex-wrap: wrap;
}
.partner_box{
    display: flex;
    width: 33.3333%;
    box-sizing: border-box;
    padding: 15px;
    justify-content: center;
    align-items: center;
}
.partner_img{
    flex:1;
    /* display: flex; */

}
.partner_img img{
    width: 100%;
    border: 1px solid #ddd;
}
.partner_text{
    flex:2;
}
.partner_title{
    color:#00a0e9;
    font-weight: 700;
    font-size: 17px;
    text-align: left;
    margin-left: 10px;
}
.partner_date{
    font-size: 15px;
    text-align: left;
    margin-left: 10px;
}
.partner_date i{
    width: 15px;
    height: 15px;
    text-align: center;
    margin: 5px 5px 0 0;
}
.partner_location{
    font-size: 15px;
    text-align: left;
    margin-left: 10px;
}
.partner_location i{
    width: 15px;
    height: 15px;
    text-align: center;
    margin: 5px 5px 0 0;
}
.partner_btn{
    color:#00a0e9;
    font-size: 15px;
    text-align: left;
    margin-left: 10px;
}
.admin_url:hover{
    color:#00a0e9;
}
.imgurl{
    display: inline-block;
    flex: 1.2;
    height: 100%;
}
/* 1152 */
@media (max-width: 1152px){
    .partner_box{
        width: 50%;
    }
}
@media (max-width: 768px){
    .partner_box{
        width: 100%;
    }
    .partner_center{
        padding: 0;
    }
    .imgurl{
        flex: 1;
    }
}
@media (max-width: 500px){
    .partner_box{
        width: 100%;
        padding: 10px 0;
    }
    .partner_img{
        flex:5;
    }
    .partner_text{
        flex:7;
    }
    .imgurl{
        flex: 4;
    }
    .partner_title{
        margin-top: 5px;
    }
}
</style>


